var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-ribbon-item-content"},[(_vm.href && _vm.text)?_c('a',{ref:"linkRef",staticClass:"vs-link-cta",class:{
      'vs-link-new-window': _vm.ctaTarget === 'newWindow',
      'vs-link-modal': _vm.ctaTarget === 'modalWindow',
      'vs-link-outside': _vm.linktype === 'external' && _vm.ctaTarget !== 'newWindow',
    },attrs:{"target":_vm.linkTarget,"rel":_vm.linkRel,"href":_vm.href,"aria-label":_vm.label},on:{"click":function($event){return _vm.onclick_emit($event)}}},[_vm._v(" "+_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }